enum PaymentType {
  cash = "現金",
  creditCard = "クレジットカード",
}

export default PaymentType;
